import { useAppDispatch, useAppSelector } from 'app/hooks';
import { COLLAPSE_ALL, EXPAND_ALL } from 'features/Store/constants';
import { COLUMN_WIDTH } from 'features/Store/pages/StoreSettingDetailPage';
import { selectStoreSettingDetailExpandAll, storeSettingDetailActions } from 'features/Store/storeSettingDetailSlice';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MINUS_TEXT, PLUS_TEXT } from 'utils';
import { UnAssignedMenu } from '../../models';
import UnAssignedMenuRow from '../UnAssignedMenuRow';

export interface UnAssignedMenuRowListProps {
  menus: UnAssignedMenu[] | null;
}

function UnAssignedMenuRowList({ menus }: UnAssignedMenuRowListProps) {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [open, setOpen] = useState(true);
  const isExpand = useAppSelector(selectStoreSettingDetailExpandAll);

  useEffect(() => {
    const btnExpandElem = document.querySelector(`#unassiged-menus-row .dan-btn-expand`) as HTMLButtonElement;
    function handleBtnExpandElemClick(event: MouseEvent) {
      event.stopPropagation();
      setOpen(!open);
      dispatch(storeSettingDetailActions.setExpandAll(undefined));
      btnExpandElem.innerHTML = !open ? MINUS_TEXT : PLUS_TEXT;
      btnExpandElem?.setAttribute('aria-expanded', !open ? 'true' : 'false');
    }

    if (btnExpandElem) {
      btnExpandElem.addEventListener('click', handleBtnExpandElemClick);
    }

    return () => {
      if (btnExpandElem) {
        btnExpandElem.removeEventListener('click', handleBtnExpandElemClick);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  useEffect(() => {
    if (isExpand !== undefined) {
      if (isExpand === EXPAND_ALL) {
        setOpen(true);
      } else if (isExpand === COLLAPSE_ALL) {
        setOpen(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isExpand]);

  return (
    <>
      <div id={`unassiged-menus-row`} className="dan-tr main content-visibility-auto">
        <div className="dan-td" style={{ width: `${COLUMN_WIDTH[0]}%` }}>
          <button
            className="dan-btn-expand"
            tabIndex={-1}
            aria-controls={`unassigned-menus-content`}
            aria-expanded={open}
          >
            {open ? MINUS_TEXT : PLUS_TEXT}
          </button>
          <span>{t('StoreSettingDetailPage.unassigned')}</span>
        </div>
        <div
          className="dan-td"
          style={{
            width: `${COLUMN_WIDTH.slice(1, 17).reduce((sum, width) => sum + width, 0)}%`,
          }}
        ></div>
      </div>
      <div style={{ contentVisibility: open ? 'visible' : 'hidden' }}>
        <div id={`unassigned-menus-content`}>
          {menus?.map(function (menu) {
            return <UnAssignedMenuRow key={menu.id} menu={menu} />;
          })}
        </div>
      </div>
    </>
  );
}

export default UnAssignedMenuRowList;
